module.exports = __webpack_public_path__ + "35e9e4b43a5f8a212c11a13366effdb8.fbx";